import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, SparklesIcon, StarIcon } from 'lucide-react';
const CUSTOMER_DISHES = [{
  src: 'https://cdn.magicpatterns.com/uploads/7f8XJqzMTm6hUYSyahkgCa/ChatGPT_Image_26_jul_2026,_05_51_54_p.m.png',
  alt: 'Milanesas caseras con papas y empanadas servidas en una mesa familiar',
  label: 'Cena familiar resuelta'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nz9B3qnYEnMLLx58hnZaBp/ChatGPT_Image_26_jul_2026,_05_49_10_p.m.png',
  alt: 'Pizza casera con queso fundido',
  label: 'Pizza casera'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/croDmjRayLM9zgtgdLowTN/ChatGPT_Image_26_jul_2026,_05_46_24_p.m.png',
  alt: 'Canastitas caseras de verduras y queso',
  label: 'Canastitas crocantes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5fE5CJS8xTNKJ7Nb7PZdoE/ChatGPT_Image_26_jul_2026,_05_09_45_p.m.png',
  alt: 'Pollo dorado con papas y ensalada casera',
  label: 'Pollo dorado'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/o6LDoymr1NkzzhuU5EYEy4/ChatGPT_Image_26_jul_2026,_05_08_11_p.m.png',
  alt: 'Filet de pescado con ensalada fresca',
  label: 'Pescado liviano'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ePJ13apqZbR65GCrvhQaqW/ChatGPT_Image_26_jul_2026,_05_05_32_p.m.png',
  alt: 'Canastitas de verdura y queso en una mesa familiar',
  label: 'Cena para compartir'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2uzKM43X3Ca6bx75AeMt9A/ChatGPT_Image_26_jul_2026,_05_04_59_p.m.png',
  alt: 'Pescado grillado con ensalada y limón',
  label: 'Almuerzo fresco'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xd7kQjfsKQoHTonEKf8Nk3/ChatGPT_Image_26_jul_2026,_05_01_59_p.m.png',
  alt: 'Volcán de chocolate casero con centro líquido',
  label: 'Postre de domingo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ixir5U6o9VNZjuFmjDJGZS/ChatGPT_Image_26_jul_2026,_05_00_19_p.m.png',
  alt: 'Budín casero recién cortado sobre una tabla',
  label: 'Merienda casera'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/k3FfzFng5tvNzrgsvnD3Jq/ChatGPT_Image_26_jul_2026,_04_58_31_p.m.png',
  alt: 'Brownies húmedos caseros servidos sobre tabla de madera',
  label: 'Brownies bien húmedos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uydSa8KtkmyiY4chSVXKo4/ChatGPT_Image_26_jul_2026,_04_56_30_p.m.png',
  alt: 'Tarta casera dorada recién hecha junto a una freidora de aire',
  label: 'Tarta casera'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/42gicdL11gdCf8AdfG76Jy/ChatGPT_Image_26_jul_2026,_04_52_46_p.m.png',
  alt: 'Milanesas caseras crocantes en un plato familiar',
  label: 'Milanesas crocantes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iKeiPYxqVmZmF5jDbNajki/ChatGPT_Image_26_jul_2026,_04_52_38_p.m.png',
  alt: 'Costillitas doradas con ensalada y papas',
  label: 'Costillitas al punto'
}];
export function HappyFamiliesCarousel() {
  const scrollingDishes = [...CUSTOMER_DISHES, ...CUSTOMER_DISHES];
  return <section className="w-full overflow-hidden bg-[#fff7f2] py-10 sm:py-16" data-id="element-113" data-mp="3q3zuljmtp8dt">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-114" data-mp="3v56z99to5rg9">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-orange-100 px-3 py-1 text-xs font-black uppercase text-orange-800" data-id="element-115" data-mp="3xkzhsa2m94o">
          <HeartIcon className="h-3.5 w-3.5 fill-current" data-id="element-116" data-mp="8r5qv1h5s4uw" /> Resultados de nuestra comunidad
        </span>
        <h2 className="mt-4 text-2xl font-black leading-tight text-[#0d1f36] sm:text-3xl lg:text-4xl" data-id="element-117" data-mp="dqs1d35lr700">
          Resultados reales de personas reales (De Norte a Sur de Argentina).
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg" data-id="element-118" data-mp="mnavujthf2yp">
          Estas son algunas de las cenas, meriendas y platos favoritos que las familias ya están resolviendo con su Air Fryer. Más rico, más rápido y con plata que vuelve a quedar en casa.
        </p>
      </div>

      <div className="relative mt-7" aria-label="Galería de platos preparados por familias de la comunidad" data-id="element-119" data-mp="nrawzzo20ac0">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-10 bg-gradient-to-r from-[#fff7f2] to-transparent sm:w-24" data-id="element-120" data-mp="isgg539ncvuj" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-10 bg-gradient-to-l from-[#fff7f2] to-transparent sm:w-24" data-id="element-121" data-mp="wqocb8yuzt4n" />
        <motion.div className="flex w-max gap-5 px-3" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 110,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-122" data-mp="sojk8eo274k4">
          {scrollingDishes.map((dish, index) => <figure key={`${dish.label}-${index}`} aria-hidden={index >= CUSTOMER_DISHES.length} className="relative aspect-[4/5] w-60 shrink-0 overflow-hidden rounded-2xl border-2 border-white bg-slate-100 shadow-xl sm:w-80" data-id="element-123" data-mp="du58mz6tqxfh" data-mpi={index}>
              <img src={dish.src} alt={index < CUSTOMER_DISHES.length ? dish.alt : ''} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-124" data-mp="3dh4wmewp7d0q" />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent px-3 pb-3 pt-10 text-left text-sm font-black text-white" data-id="element-125" data-mp="33ali6d402ugl">
                {dish.label}
              </figcaption>
            </figure>)}
        </motion.div>
      </div>

      <div className="mx-auto mt-7 flex max-w-2xl flex-wrap items-center justify-center gap-x-5 gap-y-2 px-4 text-sm font-bold text-[#0d1f36]" data-id="element-126" data-mp="2ydv05k8mxosj">
        <span className="flex items-center gap-1.5" data-id="element-127" data-mp="3r2sj7pko7pmc"><StarIcon className="h-4 w-4 fill-yellow-400 text-yellow-400" data-id="element-128" data-mp="3r1qwgnualeos" /> Platos reales, todos los días</span>
        <span className="flex items-center gap-1.5" data-id="element-129" data-mp="3c4qf9e9q924k"><SparklesIcon className="h-4 w-4 text-orange-600" data-id="element-130" data-mp="3h3tbqabn600x" /> Tu próxima cena puede ser la siguiente</span>
      </div>
    </section>;
}